import { render, staticRenderFns } from "./SmallVideoList.vue?vue&type=template&id=3cf84b98&scoped=true&"
import script from "./SmallVideoList.vue?vue&type=script&lang=js&"
export * from "./SmallVideoList.vue?vue&type=script&lang=js&"
import style0 from "./SmallVideoList.vue?vue&type=style&index=0&id=3cf84b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf84b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf84b98')) {
      api.createRecord('3cf84b98', component.options)
    } else {
      api.reload('3cf84b98', component.options)
    }
    module.hot.accept("./SmallVideoList.vue?vue&type=template&id=3cf84b98&scoped=true&", function () {
      api.rerender('3cf84b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/classroom1/components/SmallVideoList.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/classroom1/components/SmallVideoList.vue
// module id = otd0
// module chunks = 0